import { createAsyncThunk, createSlice, isAsyncThunkAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import fetchAPI from '../../common/fetchAPI'
import { ProfileStateClass } from "./interfaces/ProfileStateClass";
import { Await } from "react-router-dom";

const initialState: ProfileStateClass = {
    isLoading: false,
    profileList: [],
    status: "idle",
    selectedRecord: {},
    isReload: false,
    IsAspNetActiveDirectoryMembershipProvider: false,
    EnablePasswordComplexity: false,
    IsEnableUploadFeature: false,
    IsEmailAvailable: true,
    IsPasswordValidate: true,
    IsTimeInOutAvailable: false
};

interface IThunkApi {
    state: {
        profile: ProfileStateClass
    }
};

export const getEmployeeProfileAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        "Employee/v2/getEmployeeProfile",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/Employees/EmployeeProfile', 'GET', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )

export const getAccountLocationByAccountLocationIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Location/v2/getAccountLocationByAccountLocationId",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/Locations/' + arg, 'GET', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )

export const updateProfileAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Employees/v2/updateProfile',
        async (arg, thunkApi) => {
            const { AccountEmployeeId, NewPassword, ...argWithoutId } = arg;
            const response = await fetchAPI('api/v2/Employees/UpdateProfile/', 'PUT', argWithoutId, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )

export const UploadElectronicSignature = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Employees/v2/UploadElectronicSignature',
        async (args, thunkApi) => {
            const { formData } = args;
            let response: any = "";
            response = await fetchAPI(`api/V2/Employees/UploadElectronicSignature`, 'POST', formData, true, 'cce1c985-3054-43d2-b262-0731a14f3ca8', true);
            const json = await response.json();
            return json;
        }
    )

export const UploadProfile = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Employees/v2/UploadProfile',
        async (args, thunkApi) => {
            const { formData } = args;
            let response: any = "";
            response = await fetchAPI(`api/V2/Employees/UploadProfile`, 'POST', formData, true, 'cce1c985-3054-43d2-b262-0731a14f3ca8', true);
            const json = await response.json();
            return json;
        }
    )
export const IsCurrentPasswordValidate = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Employees/GetIsCurrentpasswordvalidate',
        async (arg, thunkApi) => {
            //const { email, accessToken } = thunkApi.getState().profile;
            const { Username, Password } = arg;
            // const response = await fetchAPI(`api/V2/Employees/GetIsCurrentpasswordvalidate/${Username}/${Password}`, `Get`, '', true, 'cce1c985-3054-43d2-b262-0731a14f3ca8');
            const response = await fetchAPI("api/v2/Employees/IsCurrentPasswordValidate", "POST", { "EMailAddress": Username, "Password": Password }, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = await response.json();
            return json;
        }
    )
export const GetEmailAddressValidationAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "ExternalUsers/v2/GetEmailAddressValidation",
        async (arg, thunkApi) => {
            const { EMailAddress, AccountEmployeeId } = arg;
            // const response = await fetchAPI("api/v2/ExternalUsers/EmailAddressValidation/" + EMailAddress + "/" + AccountEmployeeId, "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const response = await fetchAPI("api/v2/ExternalUsers/EmailAddressValidation", "POST", { "EMailAddress": EMailAddress, "AccountEmployeeId": AccountEmployeeId }, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }

    )

export const profileSlice = createSlice({
    name: 'profile',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};
        }
    },

    extraReducers: (builder) => {
        builder
            .addCase(getEmployeeProfileAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getEmployeeProfileAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';

                if (Object.keys(payload.employeeProfileData).length === 0) {
                    state.profileList = [];
                }
                else {
                    state.profileList = payload.employeeProfileData;
                    state.selectedRecord = payload.employeeProfileData[0];
                    // state.profileList.map((item: any) => {
                    //     item.isSelected = 0
                    // });
                    state.IsTimeInOutAvailable = payload.employeeProfileData[0].IsTimeInOutAvailable;
                }
                state.IsAspNetActiveDirectoryMembershipProvider = payload.IsAspNetActiveDirectoryMembershipProvider;
                state.EnablePasswordComplexity = payload.EnablePasswordComplexity;
                state.IsEnableUploadFeature = payload.IsEnableUploadFeature;
                state.isReload = false;
                state.isLoading = false;

            })
            .addCase(getEmployeeProfileAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(updateProfileAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(updateProfileAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(updateProfileAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })


            .addCase(UploadElectronicSignature.pending, state => {
                state.status = 'loading';
            }).addCase(UploadElectronicSignature.fulfilled, (state, { payload }) => {
                state.status = 'idle';

            }).addCase(UploadElectronicSignature.rejected, (state) => {
                state.status = 'failed';
            })


            .addCase(UploadProfile.pending, state => {
                state.status = 'loading';
            }).addCase(UploadProfile.fulfilled, (state, { payload }) => {
                state.status = 'idle';

            }).addCase(UploadProfile.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(IsCurrentPasswordValidate.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(IsCurrentPasswordValidate.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.IsPasswordValidate = payload;
                state.isLoading = false;
            })
            .addCase(IsCurrentPasswordValidate.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(GetEmailAddressValidationAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(GetEmailAddressValidationAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.IsEmailAvailable = payload;
                state.isLoading = false;
            })
            .addCase(GetEmailAddressValidationAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
    }

});

export const { resetSelectedRecordObjectInState } = profileSlice.actions
export const profileState = (state: RootState) => state.profile
export default profileSlice.reducer
